import PropTypes from 'prop-types';

import { CustomTypography } from 'src/components/CustomTypography';

import { preparePropTypesFromChildComponent } from '../../lib';
import { BlockedSectionContent } from '../BlockedSectionContent';
import { InsightBox } from '../InsightBox';

import { ChartAudience } from './components/ChartAudience';
import { HistogramAgeScore } from './components/HistogramAgeScore';
import { HistogramGenderScore } from './components/HistogramGenderScore';
import { useStyles } from './useStyles';

export const Histograms = ({
  classes,
  audienceChartProps,
  histogramAgeScoreProps,
  histogramGenderScoreProps,
}) => {
  const styles = useStyles({ classes });

  return (
    <div className={styles.root}>
      <CustomTypography className={styles.boxGroupTitle}>Target audiences</CustomTypography>

      {audienceChartProps?.blockedReason ? (
        <InsightBox className={styles.content}>
          <BlockedSectionContent
            title="Unable to retrieve insights for target audiences"
            description="We cannot provide target audience insights for texts longer than 200 words."
          />
        </InsightBox>
      ) : (
        <div className={styles.histograms}>
          {audienceChartProps && (
            <ChartAudience
              className={styles.chartAudience}
              {...audienceChartProps}
            />
          )}

          <div className={styles.histogramsWrapper}>
            <>
              {histogramAgeScoreProps && (
                <HistogramAgeScore
                  className={styles.histogramAge}
                  {...histogramAgeScoreProps}
                />
              )}

              {histogramGenderScoreProps && (
                <HistogramGenderScore
                  className={styles.histogramGender}
                  {...histogramGenderScoreProps}
                />
              )}
            </>
          </div>
        </div>
      )}
    </div>
  );
};

Histograms.propTypes = {
  classes: PropTypes.shape(),
  audienceChartProps: preparePropTypesFromChildComponent(ChartAudience.propTypes),
  histogramAgeScoreProps: preparePropTypesFromChildComponent(HistogramAgeScore.propTypes),
  histogramGenderScoreProps: preparePropTypesFromChildComponent(HistogramGenderScore.propTypes),
  showBrandVoiceSettings: PropTypes.bool,
};

Histograms.defaultProps = {
  classes: null,
  audienceChartProps: null,
  histogramAgeScoreProps: null,
  histogramGenderScoreProps: null,
  showBrandVoiceSettings: false,
};
